export function parseError(e: any, fallback = undefined) {
  return e?.response?.data?.messageFa ??
    e?.response?.data?.message ??
    e?.message ??
    fallback ??
    e;
}

export function parseErrorKey(e: any, fallback = 'UNKNOWN_ERROR') {
  return e?.response?.data?.messageResource ?? fallback;
}

export default parseError;
